(() => {
  const sizeKey = value => (String(value).match(/\d+(?:[.,]\d+)?/g) || []).join("|");
  const boot = () => document.querySelectorAll('section:has(.bw-ft-size)').forEach(section => {
    if (section.dataset.ftSizesReady) return;
    section.dataset.ftSizesReady = 'true';
    const table = section.querySelector('.bw-ft-size table');
    const rows = [...table.tBodies[0].rows];
    const headers = [...table.tHead.rows[0].cells].map(cell => cell.textContent.trim());
    const picker = section.querySelector('variant-selects');
    if (!picker) return;
    const update = () => {
      const select = [...picker.querySelectorAll('select')].find(input => input.options.length && [...input.options].every(option => rows.some(row => sizeKey(row.dataset.sizeValue) === sizeKey(option.value))));
      if (!select) return;
      select.closest('.product-form__input')?.classList.add('bareway-size-picker');
      [...select.options].forEach(option => {
        const row = rows.find(row => sizeKey(row.dataset.sizeValue) === sizeKey(option.value));
        if (!row) return;
        const values = [...row.cells].map(cell => cell.textContent.trim());
        const label = [2,1,0].filter(index => values[index] !== '—').map(index => `${headers[index]} ${values[index]}`).join(' / ');
        if (option.textContent.trim() !== label) option.textContent = label;
      });
      rows.forEach(row => row.classList.toggle('bw-ref-selected', sizeKey(row.dataset.sizeValue) === sizeKey(select.value)));
    };
    let queued = false;
    const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); };
    picker.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(picker, { childList: true, subtree: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
